<template>
  <div class="bigbox">
    <header>
      <div class="head">
        <a @click="taxa()"><img src="../../../static/img/back.png" alt=""></a>
        <h2>查询结果</h2>
        <img src="../../../static/img/many.png" alt="">
      </div>
    </header>
    <section>
      <article>
        <div class="Topmain">
          <a href="javascript:;">记录增值税</a>
          <a @click="sale()">记录营业税金及附加</a>
          <a href="javascript:;" @click="Recordincome()">记录所得税</a>
          <a @click="findfees()" >查询税费</a>
        </div>
        <div class="maincon">
          <div class="Centermain">
            <div class="topCon">
              <div class="topcon">
                <h2>查询结果</h2>
                <input class="js-startdate-picker" type="text" v-model="selectBirthDate" readonly>
              </div>
              <div class="topcon1">
                <h2>增值税金额</h2>
                <input type="text" v-model="vatamount" readonly>
              </div>
            </div>
            <div class="botcon">
              <h2>增值税子类别</h2>
              <li class="inCon1">
                <p>进项税额</p>
                <input type="text"  v-model="Jingamount" readonly>
              </li>
              <li class="inCon1">
                <p>销项税额</p>
                <input type="text" v-model="Xiaoamount" readonly>
              </li>
              <li class="inCon1">
                <p>出口退税</p>
                <input type="text" v-model="ChuKouamount" readonly>
              </li>
            </div>
          </div>
          <div class="Centermain1" >
            <div class="con">列表明细</div>
            <li class="icon1" v-for="(item,i) in TaxList" :key="i" >
              <p class="iconleft">
                <span>{{item.AffirmDate}}</span>
                <i>{{item.State}}</i>
              </p>
              <div class="iconright">
                <!--<p v-show="item.State=='未结转'" id="fow" @click="fow(i)">结转</p>-->
                <p class="iconright1">
                  <span>{{item.TaxName}}</span>
                  <i>{{item.TaxAmount}}</i>
                </p>
              </div>
            </li>
          </div>
        </div>
      </article>
    </section>
    <footer>
      <div class="btn" @click="taxa()" id="a">
        返回
      </div>
    </footer>
  </div>
</template>

<script>
    export default {
        name: "VATyear",
      data(){
        return{
          selectBirthDate:'',
          TaxList:[],
          vatamount:'',
          Xiaoamount:'',
          Jingamount:'',
          ChuKouamount:''
        }
      },
      mounted(){
        this.BirthDateSelect()
        this.GetTaxReportIsends()
        this.GetYearilTaxList()
      },
      methods: {
        fow(i){
          console.log(i)
          this.$axios({
            method:'post',
            url:'/fmsapi/TaxProvisionRecord/GetDetailTaxList',
            data:this.$qs.stringify({
              C_GUID: sessionStorage.getItem('companyId'),
              AffirmDate:sessionStorage.getItem('vatyear'),
              period: 'year'
            })
          }).then(res=>{
            console.log(res.data.result[i])
            sessionStorage.setItem('GUIDyear',res.data.result[i].GUID)
            sessionStorage.setItem('TaxAmountyear',res.data.result[i].TaxAmount)
            sessionStorage.setItem('TaxNameyear',res.data.result[i].TaxName)
            sessionStorage.setItem('AffirmDateyear',res.data.result[i].AffirmDate)
            console.log(sessionStorage.getItem('GUIDyear'))
            if(sessionStorage.getItem('GUIDyear')&&sessionStorage.getItem('TaxAmountyear')&&sessionStorage.getItem('TaxNameyear')&&sessionStorage.getItem('AffirmDateyear')){
              this.$axios({
                method:'post',
                url:'/fmsapi/TaxProvisionRecord/JieZhuanDetail',
                data:this.$qs.stringify({
                  C_GUID:sessionStorage.getItem('companyId'),
                  GUID:sessionStorage.getItem('GUIDyear'),
                  Amount:sessionStorage.getItem('TaxAmountyear'),
                  TaxAmount:sessionStorage.getItem('TaxAmountyear'),
                  Name:'应交税费',
                  TaxName:sessionStorage.getItem('TaxNameyear'),
                  Date:sessionStorage.getItem('AffirmDateyear')
                })
              }).then(res=>{
                console.log(res.data)
                window.location.reload()
              })
            }
          })
        },
        BirthDateSelect() {
          var calendar = new datePicker();
          calendar.init({
            trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
            type:
              "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
            minDate: "1900-1-1" /*最小日期*/,
            maxDate: "2100-12-31" /*最大日期*/,
            onSubmit: function () {
              /*确认时触发事件*/
              var theSelectData = calendar.value;
            },
            onClose: function () {
              /*取消时触发事件*/
            }
          });
        },
        find() {
          this.$router.push({path: '/findresults'})
        },
        sale() {
          this.$router.push({path: '/sale'})
        },
        findfees() {
          this.$router.push({path: '/findfees'})
        },
        taxa() {
          this.$router.push({path: '/taxa'})
        },
        back() {
          this.$router.push('/home')
        },
        Recordincome() {
          this.$router.push({path: '/Recordincome'})
        },
        GetTaxReportIsends() {
          this.$axios({
            method: 'post',
            url: 'fmsapi/TaxProvisionRecord/GetTaxReportIsends',
            data: this.$qs.stringify({
              C_GUID: sessionStorage.getItem('companyId'),
              reportDate: sessionStorage.getItem('vatyear'),
              period: 'year',
              isend: '0',
            })
          }).then(res => {
            this.selectBirthDate=sessionStorage.getItem('vatyear')
            this.vatamount = JSON.stringify(res.data.result[0].XiaoAmount)
            this.Xiaoamount = JSON.stringify(res.data.result[0].XiaoAmount)
            this.Jingamount = JSON.stringify(res.data.result[0].JingAmount)
            this.ChuKouamount = JSON.stringify(res.data.result[0].ChuKouAmount)
            sessionStorage.setItem('vatamountyear', JSON.stringify(res.data.result[0].XiaoAmount))
            sessionStorage.setItem('JingAmountyear', JSON.stringify(res.data.result[0].JingAmount))
            sessionStorage.setItem('ChuKouAmountyear', JSON.stringify(res.data.result[0].ChuKouAmount))
            sessionStorage.setItem('ChuNeiAmountyear',JSON.stringify(res.data.result[0].ChuNeiAmount))
            sessionStorage.setItem('XiaoChuAmountyear',JSON.stringify(res.data.result[0].XiaoChuAmount))
            console.log(res.data.result[0])
            console.log(this.vatamount)
          })
        },

        GetYearilTaxList(){
          this.$axios({
            method:'post',
            url:'/fmsapi/TaxProvisionRecord/GetDetailTaxList',
            data:this.$qs.stringify({
              C_GUID:sessionStorage.getItem('companyId'),
              AffirmDate: sessionStorage.getItem('vatyear'),
              period:'year'
            })
          }).then(res=>{
            var btn=document.getElementById('btncon')
            console.log(btn)
            this.TaxList = res.data.result
            for (var i=0;i<this.TaxList.length;i++){
              console.log(this.TaxList[i].State)
              if(this.TaxList[i].State==='未结转'){
                btn.style.display='block'
              }else {
                btn.style.display='none'
              }
            }
          })
        },
      }
    }
</script>

<style scoped>
  html,body{
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  /*大盒子，首位固定*/
  .bigbox{
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;

  }
  /*头部固定*/
  header{
    height: 0.325rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff
  }
  /*头部标题*/
  .head{
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 0.13rem;
    color: black;
  }
  /*标题样式*/
  .head h2{
    display: block;
    width: 2.5rem;
    text-align: center;
  }
  .head img:last-child {
    width: 0.15rem;
    height: 0.11rem;
  }
  .head img:first-child{
    width: 0.09rem;
    height: 0.17rem;
  }
  section{
    flex: 1;
    overflow:auto;
  }
  #fow{
    color: #2626fd;
    font-size: 0.13rem;
    margin-right: 0.12rem;
    margin-top: 0.13rem;
  }
  .Topmain{
    height: 1.05rem;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
  .Topmain a{
    display: block;
    width: 1.07rem;
    height: 0.33rem;
    background:white;
    border-radius: 8px;
    color: black;
    text-align: center;
    line-height: 0.32rem;
    margin-left: 10px;
  }
  .Topmain a:first-child{
    background: #09a9bf;
    color: white
  }
  .maincon{
    width: 100%;
  }
  .Centermain{
    height: 2rem;
    background: #ffffff;
  }
  .inCon1{
    height: 0.28rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .inCon1 p{
    width: 1.21rem;
    height:100%;
    line-height: 0.28rem;
    font-size: 0.13rem;
    color: black;
  }
  .inCon1 input{
    display: block;
    width: 1.37rem;
    height: 0.28rem;
    font-size: 0.13rem;
    text-align: right;
  }
  .topcon ,.topcon1{
    height: 0.46rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.19rem;

  }
  .topcon1{
    height: 0.3rem;
  }
  .topcon h2{
    height:100%;
    line-height: 0.46rem;
    font-size: 0.15rem;
    color: #09a9bf;
  }
  .topcon1 h2{
    color: black;
    height:100%;
    line-height: 0.3rem;
    font-size: 0.13rem;
  }
  .topcon input ,.topcon1 input{
    display: block;
    width: 1.37rem;
    height: 0.46rem;
    font-size: 0.14rem;
    text-align: right;
  }
  .topcon1 input{
    font-size: 0.13rem;
  }
  .botcon{
    height: 0.96rem;
    margin-top: 0.1rem;
    padding: 0 0.19rem;
  }
  .botcon h2{
    line-height: 0.3rem;
    font-size: 0.15rem;
    color: #09a9bf;
  }
  .Centermain1{
    padding: 0 0.19rem
  }
  .Centermain1 li{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 0.59rem;
    color: black;
    border-bottom: 1px solid #d8d8d8;
  }
  .con{
    height: 0.5rem;
    color: #09a9bf;
    font-size: 0.14rem;
    line-height: 0.54rem;
    border-bottom: 1px solid #d8d8d8
  }
  .icon1{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .iconleft{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .iconleft span{
    font-size: 0.09rem;
    color: #979797;
  }
  .iconleft i{
    font-size: 0.14rem;
    color: black;
  }
  .iconright{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .iconright1{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 0.8rem;
    text-align: right;
  }
  .iconright1 span{
    font-size: 0.1rem;
    color: #979797;
  }
  .iconright1 i{
    font-size: 0.13rem;

  }
  .iconright a img{
    width: 0.15rem;
    height: 0.14rem;
  }
  footer{
    display: flex;
    height: 0.55rem;
    background: white;
    justify-items: center;
    align-items: center;
  }
  .btn{
    margin: 0 auto;
    width: 3.35rem;
    height: 0.35rem;
    background: #379ce2;
    font-size: 0.14rem;
    text-align: center;
    line-height: 0.35rem;
    border-radius: 20px;
  }
  #btncon{
    margin: 0 auto;
    width: 3.35rem;
    height: 0.35rem;
    background: #379ce2;
    font-size: 0.14rem;
    text-align: center;
    line-height: 0.35rem;
    border-radius: 20px;
  }
</style>
